import React from 'react'
import { graphql } from 'gatsby';
import HomeLayout from '../layouts/HomeLayout'
import SkillsCloud from '../components/SkillsCloud'
import ContactForm from '../components/ContactForm'


export const query = graphql`
query cvQuery {
  allContentfulCv {
    edges {
      node {
        id
        firstName
        lastName
        dateOfBirth
        photo {
          id
          title
          resize(width: 246,quality:100) {
            src
          }
        }
        email,
        phone
      }
    }
  },
  allContentfulEducation(sort: {fields: startDate,order:ASC}) {
    edges {
      node {
        id
        title
        startDate
        endDate
        image {
          id
          title
          sizes {
            src
          }
        }
        description {
          childMarkdownRemark{
            html
          }
        }
      }
    }
  },
  allContentfulExperience(limit:4, sort: {fields: startDate,order:DESC}) {
    edges {
      node {
        id
        title
        startDate
        endDate
        image {
          id
          title
          sizes {
            src
          }
        }
        description {
          childMarkdownRemark{
            html
          }
        }
      }
    }
  },
  allContentfulAchievement(limit:4, sort: {fields: period,order:DESC}) {
    edges {
      node {
        id
        title
        url
        subtitle
        period
        image {
          id
          title
          resize(width: 350,quality:100) {
            src
          }
        }
        description {
          childMarkdownRemark{
            html
          }
        }
        technologies
      }
    }
  },
  allContentfulSkill {
    edges {
      node {
        title
        level
      }
    }
  }
}
`

class IndexPage extends React.Component {
  constructor(props) {
    super(props);
    let query = new URLSearchParams(props.location.search);

    this.state = {
      cv: props.data.allContentfulCv.edges[0].node,
      educations: props.data.allContentfulEducation.edges,
      experiences: props.data.allContentfulExperience.edges,
      totalExperienceTime: Math.floor(props.data.allContentfulExperience.edges.map(
        (element, key) => { 
          let year = this.getWorkingYear(element);
          let month = this.getWorkingMonth(element);
          let total = year + month/12;
        return total; 
      }).reduce((accumulator, currentValue) => accumulator + currentValue)),
      skills: props.data.allContentfulSkill.edges.map((element, key) => { return { text: element.node.title, value: element.node.level } }),
      achievments: props.data.allContentfulAchievement.edges,
      currentURL: props.location.href,
      messageSent: query.get('messageSent') === 'true',
    };

    /*today: new Date().getFullYear(),
      dob: new Date(this.state.cv.dateOfBirth).getFullYear(),*/
  }

  getWorkingYear(element) {
    let start = new Date();
    let end = new Date();
    if (element.node.startDate != null) {
      start = new Date(element.node.startDate);
    }
    if (element.node.endDate != null) {
      end = new Date(element.node.endDate);
    }
    let years = Math.floor(Number.parseFloat(((end.getTime() - start.getTime()) / 1000) / (3600 * 24*365)));
    return years;
  }

  getWorkingMonth(element) {
    let start = new Date();
    let end = new Date();
    if (element.node.startDate != null) {
      start = new Date(element.node.startDate);
    }
    if (element.node.endDate != null) {
      end = new Date(element.node.endDate);
    }
    let months = Number.parseFloat(((end.getTime() - start.getTime()) / 1000) / (3600 * 24 * 30.4),1).toFixed(0);
    let diff = months % 12;

    return diff;
  }


  getWorkingLabel(element) {
    let years = this.getWorkingYear(element);
    let months = this.getWorkingMonth(element);
    let label;
    
     if(years===0 && months>0){
      label = months + ' mois';
    } else if(years===1 && months===0) {
      label = years + ' an';
    } else if(years===1 && months>0) {
      label = years + ' an et '+ months + ' mois';
    } else if(years>1 && months>0) {
      label = years + ' ans et '+ months + ' mois';
    }

    return label;
  }


  getWorkingYearLabel(element) {
    let years = this.getWorkingYear(element);
    if (years === 1) {
      years = years + ' an';
    } else {
      years = years + ' ans';
    }
    return years;
  }

  //todo remove offset+15
  getYearStyle(element) {
    const w = 15+(this.getWorkingYear(element) / this.state.totalExperienceTime) * 100;
    return {
      width: w + '%'
    }
  }

  getProgressBarStyle(element) {
    let barClass = 'progress-bar'
    if (element.node.endDate === null) {
      barClass = barClass + ' current-exp-progress-bar progress-bar-striped progress-bar-animated';
    }
    return barClass;
  }

  render() {
    return (

      <HomeLayout
        title="Accueil"
        description="Alexandre Gadiou, Ingénieur, Java, J2EE, Développement, Développeur, Web, Le Mans"
        keywords="Alexandre Gadiou - Ingénieur Java/J2EE"
      >

        <header id="presentation" className="presentation">
          <img className="photo-cv rounded-circle" src={this.state.cv.photo.resize.src} alt={this.state.cv.photo.title} />
          <h1 >{this.state.cv.firstName + ' ' + this.state.cv.lastName}</h1>
          <h2>Web Developer - Le Mans - France</h2>
        </header>

        <section id="a-propos" className="about">
          <div className="container">
            <h2>À propos</h2>
            <hr />
            <div className="text-center">
              <p>
                Je suis développeur web spécialisé dans les technologies front-end.
              </p>
              <p>
                Le but de ce site est d'exposer mon CV et de vous confirmer mon intéret pour le web. 
              </p>
              <p>
                L'architecture de ce site est de type <a href="https://jamstatic.fr/2018/05/31/startups-jamstack/" target="_blank" rel="noopener noreferrer">JAMStack</a>. Il a été codé avec <a href="https://www.gatsbyjs.org/" target="_blank" rel="noopener noreferrer">GatsbyJS</a>, un CMS basé sur la technologie React.
              </p>
              <p>
                Spécialisé sur le CMS <a href="http://www.jahia.com" target="_blank" title="jahia.com" rel="noopener noreferrer">Jahia</a>, je travaille actuellement au Mans chez Covéa.
              </p>
            </div>
          </div>
        </section>

        <section id="formation" className="education">
          <div className="container">
            <h2>Formation</h2>
            <hr />
            <div className="card-deck">
              {this.state.educations.map((element, key) =>
                <div key={key} className="card">
                  <img className="card-img-top" src={element.node.image.sizes.src} alt={element.node.image.title} />
                  <div className="card-body">
                    <h3>{element.node.title}</h3>
                    <div className="card-text" dangerouslySetInnerHTML={{
                      __html: element.node.description.childMarkdownRemark.html,
                    }} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        <section id="competences" className="skills">
          <div className="container">
            <h2>Compétences</h2>
            <hr />
            <div className="text-center">

              <SkillsCloud skills={this.state.skills} />
              <ul className='sr-only'>
                {this.state.skills.map((element, key) =>
                  <li key={key}>
                    <span>{element.text}</span>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </section>


        <section id="experiences" className="experiences">
          <div className="container">
            <h2>Expériences</h2>
            <hr />

            <div className="card-deck">
              {this.state.experiences.slice(0,3).map((element, key) =>
                <div key={key} className="card">
                  <img className="card-img-top" src={element.node.image.sizes.src} alt={element.node.image.title} />
                  <div className="card-body">
                    <h3>{element.node.title}</h3>
                    <div className="card-text" dangerouslySetInnerHTML={{
                      __html: element.node.description.childMarkdownRemark.html,
                    }} />
                    <div className="progress">
                      <div className={this.getProgressBarStyle(element)} style={this.getYearStyle(element)} role="progressbar" aria-valuenow={this.getWorkingYear(element)} aria-valuemin='0' aria-valuemax={this.state.totalExperienceTime} aria-label={'Durée de l\'expérience '+element.node.title}><span>{this.getWorkingLabel(element)}</span></div>
                    </div>
                  </div>
                </div>
              )}
            </div>

          </div>
        </section>

        <section id="realisations" className="achievments">
          <div className="container">
            <h2>Réalisations</h2>
            <hr />
            {this.state.achievments.map((element, key) =>
              <article key={key} className="article">
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4">
                    <img className="card-img-top" src={element.node.image.resize.src} alt={element.node.image.title} />
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-7 col-lg-8">
                    <h3 className="title">
                      <a href={element.node.url} >{element.node.title}</a>
                    </h3>
                    <div className="text" dangerouslySetInnerHTML={{
                      __html: element.node.description.childMarkdownRemark.html,
                    }} />

                    <div>
                      <strong>Mots clefs</strong> : {element.node.technologies.join(", ")}
                    </div>

                  </div>
                </div>
              </article>
            )}
          </div>
        </section>

        <section id="contact" className="contact">
          <div className="container">
            <h2>Contact</h2>
            <hr />
            <ContactForm messageSent={this.state.messageSent} mailTo={this.state.cv.email} redirectTo={this.state.currentURL} />
          </div>
        </section>

      </HomeLayout>
    );
  }
}

export default IndexPage;













